const ParsetPOIDummy = [
  {
    industry_id: 1,
    industry_code: '11',
    industry_name: 'Bank and Financial Institution',
    industry_icon_color: '#976ADA',
    industry_status: 'T',
    group_id: 1,
    group_code: '1101',
    group_name: 'Bank',
    group_icon: '/Group/1.svg',
    group_icon_color: null,
    group_status: 'T',
    category_id: 1,
    category_code: '110101',
    category_name: 'ATM',
    category_icon: '/Category/1.svg',
    category_icon_color: null,
    category_status: 'T',
    group_poi: [
      {
        id: 1,
        type: 'Brand',
        group_brand: [
          {
            brand_id: 1,
            brand_code: '110101001',
            brand_name: 'Allo Bank Indonesia',
            brand_icon: null,
            brand_status: 'T',
          },
          {
            brand_id: 2,
            brand_name: 'ATM Bersama',
            brand_code: '110101002',
            brand_description: null,
            brand_icon: null,
            brand_status: 'T',
          },
          {
            brand_id: 3,
            brand_name: 'Bank Agris',
            brand_code: '110101003',
            brand_description: null,
            brand_icon: null,
            brand_status: 'T',
          },
        ],
      },
      {
        id: 2,
        type: 'Criteria',
        group_criteria: [
          {
            criteria_id: 1,
            criteria_value: 'Unspecified',
            criteria_key: 'Criteria',
            criteria_icon: null,
            criteria_status: null,
          },
        ],
      },
    ],
  },
  {
    industry_id: 2,
    industry_code: '11',
    industry_name: 'Bank and Financial Institution',
    industry_icon_color: '#976ADA',
    industry_status: 'T',
    group_id: 2,
    group_code: '1101',
    group_name: 'Bank',
    group_icon: '/Group/1.svg',
    group_icon_color: null,
    group_status: 'T',
    category_id: 2,
    category_code: '110102',
    category_name: 'ATM Drive Thru',
    category_icon: '/Category/2.svg',
    category_icon_color: null,
    category_status: 'T',
    group_poi: [
      {
        id: 1,
        type: 'Brand',
        group_brand: [
          {
            brand_id: 124,
            brand_name: 'Unspecified',
            brand_code: '110102400',
            brand_description: null,
            brand_icon: null,
            brand_status: 'T',
          },
        ],
      },
    ],
  },
];
const optionIndusry = [
  { label: 'Bank & Finance', id: 1, value: 1 },
  { label: 'Food & Bevarage', id: 2, value: 2 },
];
const optionGroup = [
  { label: 'Atm', id: 1, value: 1 },
  { label: 'Bank Branch', id: 2, value: 2 },
];
const ParsetEditPOI = {
  id_parameter: 7929,
  type: 'general',
  name: 'poi gruop',
  poi_for_user: 1723,
  brand: [
    {
      id: 57136,
      industry_id: 1,
      group_id: 1,
      category_id: 1,
      brand_id: 1,
      status: 'T',
    },
    {
      id: 57137,
      industry_id: 1,
      group_id: 1,
      category_id: 1,
      brand_id: 2,
      status: 'T',
    },
    {
      id: 57138,
      industry_id: 1,
      group_id: 1,
      category_id: 1,
      brand_id: 3,
      status: 'T',
    },
    {
      id: 57139,
      industry_id: 2,
      group_id: 2,
      category_id: 2,
      brand_id: 124,
      status: 'T',
    },
  ],
  criteria: [
    {
      id: 14485,
      industry_id: 1,
      group_id: 1,
      category_id: 1,
      criteria_id: 1,
      status: 'T',
    },
  ],
};

export const ParsetPoi = {
  optionIndusry,
  optionGroup,
  ParsetPOIDummy,
  ParsetEditPOI,
};
